import apiConfig, {
  ERROR_TIMEOUT,
  ADD_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  LOGO,
  CONTRACT_ATTACHMENTS,
  ATTACHMENTS,
  STATUS_LETTER_LOGO,
  INVALID_SESSION,
  PREFERED_LANGUAGE_KEYS,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import history from "../../utilities/history";
import { closeRemoveModal } from "./modalActions";
import { getAllActiveCases } from "./attachmentsAction";
import { getEmployeebyManager } from "./managerApplicantAction";
import * as utilities from "../../utilities/utils";
import { setLanguage } from "redux-i18n";

/************************************ ACTIONS ****************************************/

export function setManagerDetailsAction(managersDetails) {
  return {
    type: types.SET_MANAGER_DETAILS,
    managersDetails,
  };
}

function setProfilePhoto(profileImageURL) {
  return {
    type: types.SET_UPDATED_PROFILEPHOTO,
    profileImageURL,
  };
}

function setIsSessionValid(isSessionValid) {
  return {
    type: types.IS_SESSION_VALID,
    isSessionValid,
  };
}

function setLastLoginDetailsAction(lastLoginDetails) {
  return {
    type: types.SET_LASTLOGIN_DETAILS,
    lastLoginDetails,
  };
}

/************************************ ACTION CREATORS ****************************************/

export const isSessionValid = (errorMessage) => (dispatch) => {
  if (errorMessage === INVALID_SESSION) {
    dispatch(setLoaderAction(false));
    dispatch(setIsSessionValid(true));
    setTimeout(() => {
      dispatch(setIsSessionValid(false));
      dispatch(toastAction.showErrorMessage(false, ""));
    }, ERROR_TIMEOUT);
    utilities.removeToken();
    history.push("/");
    return true;
  }
};

export const resetProfilePhoto = () => (dispatch) => {
  dispatch(setProfilePhoto(undefined));
};

export const prepareManagerData = () => (dispatch) => {
  dispatch(getManagersDetails());
};

export const resetCompanyIdInManagerData = (companyId, profileReducer) => (dispatch) => {
  // dispatch(getManagersDetails());
  let UpdatedManagersDetails = profileReducer.managersDetails;
  UpdatedManagersDetails.companyId = companyId;
  dispatch(setManagerDetailsAction(UpdatedManagersDetails)); 
  let updatedProfileReducer = profileReducer;
  updatedProfileReducer.managersDetails = UpdatedManagersDetails;
  // dispatch(getAllActiveCases(updatedProfileReducer));
  // let pagination = {pageNo: 1, pageSize: 20, totalRows: 0};
  // dispatch(getEmployeebyManager(pagination,null,updatedProfileReducer));
};

export const getManagersDetails = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getManagersDetails()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setManagerDetailsAction(data.managersDetails));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getLastLoginInfo = (profileReducer) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getLastLoginInfo(profileReducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (!data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setLastLoginDetailsAction(data.loginActivityLogs));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const updateManagersDetails = (magagerDetails) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .updateManagersDetails(magagerDetails)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setManagerDetailsAction(data.managersDetails));
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const updateManagersLanguagePreference = (magagerDetails) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .updateManagersDetails(magagerDetails)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setManagerDetailsAction(data.managersDetails));
        dispatch(
          setLanguage(
            data.managersDetails.languagePreference
              ? PREFERED_LANGUAGE_KEYS.FrenchCanada
              : PREFERED_LANGUAGE_KEYS.EnglishUS
          )
        );
        dispatch(closeRemoveModal());
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const updateManagerPassword = (changePassowordInfo) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .updateManagerPassword(changePassowordInfo)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setManagerDetailsAction(undefined));
        utilities.removeToken();
        history.push("/");
        dispatch(setManagerDetailsAction(undefined));
        dispatch(closeRemoveModal());
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const uploadProfilePhoto = (file, allDetails) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .uploadFiles(file)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        if (dispatch(isSessionValid(data.errorMessage))) {
          return;
        }
        dispatch(setLoaderAction(false));
        dispatch(
          setProfilePhoto(
            // data?.fileUploadData.path.replace("~/", apiConfig.BASEURL)
            data?.fileUploadData.path

          )
        );
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const saveTreeView = (treeviewdata) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .saveTreeView(treeviewdata)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const saveEmployeeData = (emplyeeData) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .saveEmployeeData(emplyeeData)
    .then(({ data }) => {
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};



